/**
 * @desc 获取预订舱计划明细
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.CabinAdvanceMasterResponseDto>;
export function request(aono: string | number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinAdvanceMaster/getDetail/${aono}`, {
      method: "POST",

      ...options,
    }),
  );
}
